import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if user is authenticated on mount
    const token = localStorage.getItem('authToken');
    const authStatus = localStorage.getItem('isAuthenticated');
    
    if (authStatus === 'true' && token) {
      setIsAuthenticated(true);
      // Set axios default header if token exists
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    }
    setLoading(false);
  }, []);

  const login = async (username, password) => {
    try {
      const response = await axios.post('http://127.0.0.1:5000/api/admin/login', {
        username,
        password,
      }, {
        withCredentials: true, // Include cookies for session-based auth
      });

      // Handle successful login
      if (response.status === 200 || response.status === 201) {
        // Try to get token from various possible response formats
        const token = response.data?.token || 
                     response.data?.access_token || 
                     response.data?.authToken ||
                     response.data?.data?.token;
        
        // Store authentication token if provided
        if (token) {
          localStorage.setItem('authToken', token);
          axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        }
        
        // Mark as authenticated (even without token if using session-based auth)
        setIsAuthenticated(true);
        localStorage.setItem('isAuthenticated', 'true');
        return { success: true };
      }
      
      return { success: false, error: 'Login failed' };
    } catch (error) {
      // Handle error response
      let errorMessage = 'Invalid username or password';
      
      if (error.response) {
        // Server responded with error status
        errorMessage = error.response.data?.message || 
                      error.response.data?.error || 
                      error.response.data?.msg ||
                      `Login failed: ${error.response.status}`;
      } else if (error.request) {
        // Request made but no response received
        errorMessage = 'Unable to connect to server. Please check your connection.';
      } else {
        // Something else happened
        errorMessage = error.message || 'An error occurred during login';
      }
      
      return { success: false, error: errorMessage };
    }
  };

  const logout = () => {
    setIsAuthenticated(false);
    localStorage.removeItem('isAuthenticated');
    localStorage.removeItem('authToken');
    delete axios.defaults.headers.common['Authorization'];
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

